import React from 'react'
import { Button, Grid, GridCell, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import InvitationListItem from 'src/apps/Messages/components/InvitationListItem'
import { useMe, useOrganization } from 'src/graphql/hooks'

const AccountInvitationChooser = ({ invitationData }) => {
   const { me, refetch } = useMe()
   const { organization } = useOrganization()

   const { userHasAccount, userIsActiveCommunityMember } = invitationData
   const isNewGatherUser = !userHasAccount
   const isNewCommunityUser = !userIsActiveCommunityMember

   const featuredRelationship = me.invitations.find(relationship => (
      relationship.id === invitationData.relationship.id
   ))

   const featuredRoleParticpantElement = featuredRelationship && (
      featuredRelationship.elements.find(element => (
         element.__typename === 'RelationshipElementRoleParticipant' &&
         element.role.id === invitationData.targetRoleId
      ))
   )

   const otherInvitations = me?.invitations.reduce((result, relationship) => {
      const invitedRoleParticipantElements = relationship.elements.filter(element => (
         element.__typename === 'RelationshipElementRoleParticipant' &&
         element.status === 'invited'
      ))

      invitedRoleParticipantElements.forEach((element) => {
         if (featuredRoleParticpantElement?.role.id !== element.role.id) {
            result.push({
               relationship,
               roleParticipantElement: element
            })
         }
      })

      return result
   }, [])

   return (
      <View width="100%" height="100%">
         <Text size="3" color="#666">
            {isNewGatherUser && 'Thank you! You have successfully created a Gather Communities account. '}
            {isNewCommunityUser && `You are now part of the ${organization.name} community. `}
         </Text>
         <Spacer size="4" />
         {featuredRelationship && featuredRoleParticpantElement && (
            <View>
               <Text size="5" weight="medium" color="#000">
                  {`Hi ${me.firstName},`}
               </Text>
               <Spacer size="4" />
               <InvitationListItem
                  onAccept={refetch}
                  onDecline={refetch}
                  relationship={featuredRelationship}
                  roleParticipantElement={featuredRoleParticpantElement}
               />
            </View>
         )}
         {otherInvitations.length > 0 && (
            <View>
               <Spacer size="7" />
               <Text size="2" weight="medium" color="#000">
                  You also have some other pending invitations
               </Text>
               <Spacer size="0.5" />
               <Text size="1.5" color="#666">
                  You can see these invitations at any time from your inbox
               </Text>
               <Spacer size="4" />
               <Grid columns="1" spacing="0px">
                  {otherInvitations.map(({ relationship, roleParticipantElement }) => (
                     <GridCell key={roleParticipantElement.id}>
                        <InvitationListItem
                           onAccept={refetch}
                           onDecline={refetch}
                           relationship={relationship}
                           roleParticipantElement={roleParticipantElement}
                        />
                     </GridCell>
                  ))}
               </Grid>
            </View>
         )}
         <Spacer size="7" />
         <Grid columns="2[a-b] 4[c-f]" spacing="10px">
            <GridCell>
               <Button
                  width="100%"
                  size="md"
                  color="#3f68fb"
                  textColor="#fff"
                  textSize="0.9"
                  name="Go to Inbox"
                  linkTo="/messages"
               />
            </GridCell>
            <GridCell>
               <Button
                  width="100%"
                  size="md"
                  color="#eee"
                  textColor="#333"
                  textSize="0.9"
                  name="Visit Home"
                  linkTo="/"
               />
            </GridCell>
         </Grid>
         <Spacer size="10" />
      </View>
   )
}

AccountInvitationChooser.propTypes = {
   invitationData: PropTypes.object.isRequired
}

export default AccountInvitationChooser
